module.exports = __webpack_public_path__ + "img/sec_3_box5.b0b5e2ed.png";